var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlikStop = function SvgBlikStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 24,
    fill: "none",
    cursor: "pointer"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF7A82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.207 10.32c4.522-.843 7.772-3.759 7.258-6.511-.513-2.753-4.596-4.3-9.118-3.457-4.522.844-7.771 3.76-7.258 6.512.514 2.753 4.596 4.3 9.118 3.456M16.153 21.634c6.413-3.206 10.03-8.97 8.078-12.873S15.498 4.293 9.086 7.5c-6.413 3.207-10.03 8.97-8.078 12.873 1.952 3.904 8.733 4.469 15.145 1.262"
  }))));
};
export default SvgBlikStop;